import { PARTNER_TYPES } from '../../partner-types';
import { PARTNER_FEATURE_FLAGS } from '../../partner-features';
import { Roles } from '../../roles';
import { MenuItem } from '../types';

// Fleetcor reconciliation
export const fleetcorSection: MenuItem[] = [
  {
    headTitle1: 'Reconciliation Process',
    type: 'headtitle',
    requiredPartnerTypes: [PARTNER_TYPES.INDIVIDUAL_PARTNER, PARTNER_TYPES.API_PARTNER],
    requiredUserGroup: ['fleetcor'],
  },
  {
    title: 'Fleetcor Reconciliation',
    icon: 'stroke-project',
    iconf: 'fill-project',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.INDIVIDUAL_PARTNER, PARTNER_TYPES.API_PARTNER],
    requiredUserGroup: ['fleetcor'],
    children: [
      {
        path: '/individual-partners/fleetcor/reconciliation-dashboard',
        title: 'Dashboard',
        type: 'link',
        active: false,
        requiredPartnerTypes: [PARTNER_TYPES.INDIVIDUAL_PARTNER, PARTNER_TYPES.API_PARTNER],
        requiredUserGroup: ['fleetcor'],
      },
      {
        path: '/individual-partners/fleetcor/job-executions',
        title: 'Export History',
        type: 'link',
        active: false,
        requiredPartnerTypes: [PARTNER_TYPES.INDIVIDUAL_PARTNER, PARTNER_TYPES.API_PARTNER],
        requiredUserGroup: ['fleetcor'],
      },
      {
        path: '/individual-partners/fleetcor/job-executions/execution-details',
        title: 'Export Details',
        type: 'link',
        active: false,
        requiredPartnerTypes: [PARTNER_TYPES.INDIVIDUAL_PARTNER, PARTNER_TYPES.API_PARTNER],
        requiredUserGroup: ['fleetcor'],
      },
      {
        path: '/individual-partners/fleetcor/reconciliation-files',
        title: 'Download Files',
        type: 'link',
        active: false,
        requiredPartnerTypes: [PARTNER_TYPES.INDIVIDUAL_PARTNER, PARTNER_TYPES.API_PARTNER],
        requiredUserGroup: ['fleetcor'],
      },
      {
        path: '/individual-partners/reconcilation-process/fleetcor',
        title: 'File Format Guide',
        type: 'link',
        active: false,
        requiredPartnerTypes: [PARTNER_TYPES.INDIVIDUAL_PARTNER, PARTNER_TYPES.API_PARTNER],
        requiredUserGroup: ['fleetcor'],
      },
    ],
  },
];

// Exorigo/Upos callback APIs and API servers
export const exorigoUposSection: MenuItem[] = [
  {
    headTitle1: 'ryd Callback APIs',
    type: 'headtitle',
    requiredPartnerTypes: [PARTNER_TYPES.INDIVIDUAL_PARTNER],
    requiredUserGroup: ['exorigo_upos'],
  },
  {
    icon: 'stroke-info',
    iconf: 'fill-info',
    path: '/individual-partners/poland-invoice/general-info',
    title: 'General Info',
    type: 'link',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.INDIVIDUAL_PARTNER],
    requiredUserGroup: ['exorigo_upos'],
  },
  {
    icon: 'stroke-api-integration-widget',
    iconf: 'fill-api-integration-widget',
    path: '/individual-partners/poland-invoice/webhook-api-reference',
    title: 'Callback API Reference',
    type: 'link',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.INDIVIDUAL_PARTNER],
    requiredUserGroup: ['exorigo_upos'],
  },
  {
    icon: 'stroke-api-integration-widget',
    iconf: 'fill-api-integration-widget',
    path: '/individual-partners/poland-invoice/oauth-api-reference',
    title: 'OAuth2 API Reference',
    type: 'link',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.INDIVIDUAL_PARTNER],
    requiredUserGroup: ['exorigo_upos'],
  },
  {
    headTitle1: 'exorigo_upos APIs',
    type: 'headtitle',
    requiredPartnerTypes: [PARTNER_TYPES.INDIVIDUAL_PARTNER],
    requiredUserGroup: ['exorigo_upos'],
  },
  {
    icon: 'stroke-api-integration-widget',
    iconf: 'fill-api-integration-widget',
    path: '/individual-partners/poland-invoice/smart-order-api-reference',
    title: 'SmartOrder API Reference',
    type: 'link',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.INDIVIDUAL_PARTNER],
    requiredUserGroup: ['exorigo_upos'],
  },
  {
    icon: 'stroke-api-integration-widget',
    iconf: 'fill-api-integration-widget',
    path: '/individual-partners/poland-invoice/eparagon-plus-api-reference',
    title: 'e-Paragon+ API Reference',
    type: 'link',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.INDIVIDUAL_PARTNER],
    requiredUserGroup: ['exorigo_upos'],
  },
];

// Driver / account management for API partners that manage drivers with their
// own external IDs (e.g. Pairpoint, AUMOVIO). Switched on per partner with the
// "Driver / Account Management" flag in Partner Administration → Partner Features.
export const driverAccountManagementSection: MenuItem[] = [
  {
    headTitle1: 'My Fleet',
    type: 'headtitle',
    requiredPartnerTypes: [PARTNER_TYPES.API_PARTNER],
    requiresPartnerFeature: PARTNER_FEATURE_FLAGS.DRIVER_ACCOUNT_MANAGEMENT,
  },
  {
    title: 'Drivers / Accounts',
    icon: 'stroke-user',
    iconf: 'fill-user',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.API_PARTNER],
    requiresPartnerFeature: PARTNER_FEATURE_FLAGS.DRIVER_ACCOUNT_MANAGEMENT,
    children: [
      {
        path: '/driver-account-management/api-partner/accounts/list',
        title: 'Driver/Account List',
        type: 'link',
        active: false,
        requiredPartnerTypes: [PARTNER_TYPES.API_PARTNER],
        requiresPartnerFeature: PARTNER_FEATURE_FLAGS.DRIVER_ACCOUNT_MANAGEMENT,
        // The create page has no dedicated menu entry; keep the list item
        // highlighted while creating a driver (launched from this page).
        activePathPrefixes: ['/driver-account-management/api-partner/accounts/create'],
      },
      {
        path: '/driver-account-management/api-partner/accounts/details',
        title: 'Driver/Account Details',
        type: 'link',
        active: false,
        requiredPartnerTypes: [PARTNER_TYPES.API_PARTNER],
        requiresPartnerFeature: PARTNER_FEATURE_FLAGS.DRIVER_ACCOUNT_MANAGEMENT,
      },
      {
        path: '/driver-account-management/api-partner/accounts/update',
        title: 'Update Driver/Account',
        type: 'link',
        active: false,
        requiredPartnerTypes: [PARTNER_TYPES.API_PARTNER],
        requiresPartnerFeature: PARTNER_FEATURE_FLAGS.DRIVER_ACCOUNT_MANAGEMENT,
        requiredRoles: [Roles.fleet_Manager],
      },
    ],
  },
];

// Order Lookup (oilpay + allguth)
export const orderLookupSection: MenuItem[] = [
  {
    headTitle1: 'Order Lookup',
    type: 'headtitle',
    requiredUserGroup: ['oilpay', 'allguth'],
  },
  {
    path: '/order-lookup/getting-started',
    title: 'Getting Started',
    icon: 'file-text',
    iconf: 'fill-file-text',
    type: 'link',
    active: false,
    requiredUserGroup: ['oilpay', 'allguth'],
  },
  {
    path: '/order-lookup/api-reference',
    title: 'Order Lookup API Reference',
    icon: 'stroke-data-exchange-monitoring',
    iconf: 'fill-data-exchange-monitoring',
    type: 'link',
    active: false,
    requiredUserGroup: ['oilpay', 'allguth'],
  },
];

// Deeplink Management (freenet)
export const deeplinkManagementSection: MenuItem[] = [
  {
    headTitle1: 'Deeplink Management',
    type: 'headtitle',
    requiredPartnerTypes: [PARTNER_TYPES.INDIVIDUAL_PARTNER],
    requiredUserGroup: ['freenet'],
  },
  {
    path: '/deeplink-management/deeplink-generator',
    title: 'Deeplink Generator',
    icon: 'stroke-data-exchange-monitoring',
    iconf: 'fill-data-exchange-monitoring',
    type: 'link',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.INDIVIDUAL_PARTNER],
    requiredUserGroup: ['freenet'],
  },
];
